//libraries
import Vue from 'vue'

let resource = 'follow_up_action'
let resource_name = 'acción de secuencia'
let resource_name_plural = 'acciones de secuencia'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`sequence/${params.sequence_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushItem', res.data)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      params.payload = JSON.stringify(params.payload)
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        //commit('updateItem', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items.map(el => {
      el.payload = JSON.parse(el.payload)
      let { time_type, time_value } = getTimeUnit(el)
      el.time_type = time_type
      el.time_value = time_value
      return el
    }).sort((a,b) => {
      return a.step - b.step;
    })
  },
  pushItem (state, data) {
    if (data.success) {
      data.resource.payload = JSON.parse(data.resource.payload)
      let { time_type, time_value } = getTimeUnit(data.resource)
      data.resource.time_type = time_type
      data.resource.time_value = time_value
      state[resource + 's'].push(data.resource)
    }
  },
  updateItem (state, item) {
    let index = state[resource + 's'].findIndex(el => el[resource + '_id'] === item[resource + '_id'])
    if(index) {
      if(typeof item.payload === 'string') item.payload = JSON.parse(item.payload)
      state[resource + 's'].splice(index, 1, item)
    }
  },
  removeItem(state, item) {
    let index = state[resource + 's'].findIndex(el => el[resource + '_id'] === item[resource + '_id'])
    if(index >= 0) {
      state[resource + 's'].splice(index, 1)
    }
  },
}

function getTimeUnit ({after_time}) {
  let time_type = null
  let time_value = null
  if (after_time < 60) {
    time_type = 'minutes'
    time_value = after_time
  } else if (after_time >= 60) {
    let h = Math.floor(after_time / 60)
    if (h >= 24) {
      let d = Math.floor(h / 24)
      time_value = d
      time_type = 'days';
    } else {
      time_value = h
      time_type = 'hours';
    }
  }
   return { time_type, time_value }
}

export default {
  state,
  mutations,
  actions,
  getters
}
